// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/style.css
// module id = VaBq
// module chunks = 1